var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1602 17.5883C23.9885 17.5883 24.66 18.26 24.6602 19.0883V21.7934C24.6602 22.9091 24.2168 23.9793 23.4277 24.768C22.6386 25.5566 21.5687 25.9994 20.4531 25.9995H4.20801C3.09244 25.9994 2.02153 25.5566 1.23242 24.768C0.443513 23.9794 0 22.909 0 21.7934V19.0883C0.000114647 18.26 0.671713 17.5884 1.5 17.5883C2.32836 17.5883 2.99989 18.26 3 19.0883V21.7934C3 22.1128 3.12732 22.4197 3.35352 22.6459C3.57987 22.8722 3.8875 22.9994 4.20801 22.9995H20.4531C20.7736 22.9994 21.0813 22.8721 21.3076 22.6459C21.5337 22.4198 21.6602 22.1127 21.6602 21.7934V19.0883C21.6603 18.2602 22.332 17.5886 23.1602 17.5883ZM11.2695 0.438904C11.8552 -0.146363 12.8049 -0.146262 13.3906 0.438904L20.1592 7.20355C20.7451 7.78915 20.7457 8.73868 20.1602 9.32465C19.5747 9.91049 18.625 9.91091 18.0391 9.32562L13.8301 5.11859V17.7348C13.8301 18.5632 13.1585 19.2348 12.3301 19.2348C11.5018 19.2346 10.8301 18.5631 10.8301 17.7348V5.11859L6.62207 9.32562C6.03611 9.91123 5.08561 9.91061 4.5 9.32465C3.91478 8.73871 3.91528 7.78906 4.50098 7.20355L11.2695 0.438904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c9a0a2df24c950a60f9083483f970856.svg";
export { ForwardRef as ReactComponent };